import React, { Component } from 'react';
import { connect } from 'react-redux';
import UsersOnline from "../UsersOnline/UsersOnline";
import {rankSelector, feedSelector, userSelector, chapterSelector, usersOnlineSelector} from '../redux/selectors';
import {toArray} from "../common/util";


class UsersOnlineContainer extends Component {
    render() {
        return (
            <div className="panel-adt">
                <UsersOnline
                    open={this.props.leftPanelOpen}
                    ranks={this.props.ranks}
                    users={this.props.users}
                    usersOnline={toArray(this.props.usersOnline.presences).map((presence) => {
                        let user = this.props.users[presence.user];
                        user.browserLocation = presence.browserLocation;
                        user.browser = presence.browser;
                        user.discordGame = presence.discordGame;
                        user.discordGameType = presence.discordGameType;
                        user.discordLocation = presence.discordLocation;
                        user.discordStatus = presence.discordStatus;
                        user.discordUrl = presence.discordUrl;
                        user.steamStatus = presence.steamStatus;
                        user.steamGame = presence.steamGame;

                        return user
                    })}
                    anonymousUsers={this.props.usersOnline.anonymous}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ranks: rankSelector(state),
        users: userSelector(state),
        usersOnline: usersOnlineSelector(state),
        chapters: chapterSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(UsersOnlineContainer);


// WEBPACK FOOTER //
// ./src/UsersOnline/UsersOnlineContainer.js